<div id="journey-retirement-label"
     class="retired-in-days-label"
     [translate]="'LeavingInDays'"
     [translateParams]="{numberOfDays: daysToRetirement }"
>
</div>
